import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppLoadService } from '../app-load.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl: string;

  constructor(private http: HttpClient,
    private appLoadService: AppLoadService) {
    const settings = appLoadService.readEnvironSettings();
    this.baseUrl = settings.uriApi;
  }

  public get(url: string): Observable<any> {
    return this.http.get(`${this.baseUrl}${url}`, { withCredentials: true });
  }

  public post<T>(url: string, body: T): Observable<any> {
    return this.http.post(`${this.baseUrl}${url}`, body, { withCredentials: true });
  }

  public put<T>(url: string, body: T): Observable<any> {
    return this.http.put(`${this.baseUrl}${url}`, body, { withCredentials: true });
  }

  public patch<T>(url: string, body: T): Observable<any> {
    return this.http.patch(`${this.baseUrl}${url}`, body, { withCredentials: true });
  }

  public delete(url: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}${url}`, { withCredentials: true });
  }
}
